import { IFormulaireFranceState, IFormulaireGemaState, IMusicType, IRightHolders, IMusicInfo, IRole } from '../../../../Store/Formulaire/Types'
import { FormulaireSchemaType, QualityEnum, WorkTypeEnum, BeneficiarySchemaType, MediaEnum } from '../../validation/formulaire.schema'
import Moment from 'moment'

function getLastEditionDate(formulaireFrance: IFormulaireFranceState): string {
    let lastEditionDate: Date | string = new Date()
    if (
        formulaireFrance.society &&
        formulaireFrance.society.date &&
        formulaireFrance.society.date !== ''
    ) {
        lastEditionDate = formulaireFrance.society.date
    } else {
        lastEditionDate = lastEditionDate.toISOString().substring(0, 10)
    }
    return lastEditionDate
}

function getWorkType(type: IMusicType | null): WorkTypeEnum {
    if (type === IMusicType.NEW) {
        return WorkTypeEnum.NEW
    }
    if (type === IMusicType.EXISTING) {
        return WorkTypeEnum.EXISTING
    }
    if (type === IMusicType.SIGNATURE) {
        return WorkTypeEnum.SIGNATURE
    }
    return WorkTypeEnum.NEW
}

const musicToZodSchema = (music: IMusicInfo): {
    title: string;
    usedInSpotDuration: string;
    workType: WorkTypeEnum;
    beneficiaries: { names: string; qualities?: QualityEnum[] | undefined; beneficiary_id: string }[];
    iswcCode?: string;
    isrcCode?: string;
    workCode?: string;
    file_name?: string;
    work_id?: number;
} => {
    return {
        title: music.title,
        usedInSpotDuration: music?.usage_duration?.toString() || '',
        workType: getWorkType(music.type),
        iswcCode: music.code_iswc || "",
        isrcCode: music.code_isrc || "",
        workCode: music.code || "",
        beneficiaries: music.right_holders.map((rightHolder: IRightHolders) => musicRightHoldersToZodSchema(rightHolder)),
        file_name: music.file_name || undefined,
        work_id: music.id || 0,
    }
}

const musicRightHoldersToZodSchema = (rightHolders: IRightHolders): BeneficiarySchemaType => {
    return {
        beneficiary_id: rightHolders.id?.toString() || '',
        names: rightHolders.name,
        qualities: rightHolders.roles?.map(rightHolderRoleToQualityEnum),
    }
}

const rightHolderRoleToQualityEnum = (role: IRole): QualityEnum => {
    switch (role) {
        case IRole.ARTIST:
            return QualityEnum.ARTIST
        case IRole.AUTHOR:
            return QualityEnum.AUTHOR
        case IRole.COMPOSER:
            return QualityEnum.COMPOSER
        case IRole.ARRANGER:
            return QualityEnum.ARRANGER
        case IRole.EDITOR:
            return QualityEnum.EDITOR
        default:
            return QualityEnum.ARTIST
    }
}

function getFirstDiffusionDateTime(formulaireFrance: IFormulaireFranceState): string {
    let diffusionDte: any = null
    if (
        formulaireFrance.diffusion_date &&
        formulaireFrance.diffusion_date !== ''
    ) {
        diffusionDte = Moment(
            formulaireFrance.diffusion_date
        ).format('YYYY-MM-DDTHH:mm')
    }
    return diffusionDte
}

//output is undefined if formulaire is IFormulaireGemaState not sure if its still use need to ask
function mapFormulaireToZodSchema(formulaire: IFormulaireFranceState | IFormulaireGemaState): FormulaireSchemaType | undefined {
    //if formulaire is IFormulaireFranceState
    if ('marque' in formulaire) {
        const formulaireFrance = formulaire as IFormulaireFranceState
        const lastEditionDate = getLastEditionDate(formulaireFrance)
        const mediaType: MediaEnum = formulaireFrance.media.type === "Video" || formulaireFrance.media.type === MediaEnum.TV ? MediaEnum.TV : MediaEnum.RADIO

        const data = {
            spot: {
                brand: formulaireFrance.marque,
                productName: formulaireFrance.product_name,
                productNature: formulaireFrance.product_nature,
                declarant: formulaireFrance.agency,
                spotTitle: formulaireFrance.spot_title,
                duration: formulaireFrance?.duration?.toString() || '',
                arppCodes: formulaireFrance.codes_arpp,
                pubIdCodes: formulaireFrance.codes_pub_id,
                idCreaCode: formulaireFrance.id_crea_code || '',
                spotLink: `/details-${formulaireFrance.bucket_id === 1 ? 'television' : 'radio'}/${formulaireFrance.bucket_id}/${formulaireFrance.spot_id}`,
            },
            first_diffusion: {
                media: mediaType,
                broadcaster: formulaireFrance.diffuser,
                dateTime: getFirstDiffusionDateTime(formulaireFrance),
            },
            works: (formulaireFrance.music as IMusicInfo[]).map((music: IMusicInfo) => musicToZodSchema(music)),
            declarant: {
                id: formulaireFrance.society.id,
                last_edition_date: lastEditionDate,
                last_name: formulaireFrance.society.surname,
                first_name: formulaireFrance.society.name,
                company_name: formulaireFrance?.society?.user_group_info?.name,
            },
            should_send_to_sacem: formulaireFrance.should_send_to_sacem,
        }
        return data
    }
}

export const domainToZodMapper = {
    mapFormulaireToZodSchema,
}